import { Box, Stack, Typography, TextField, Grid, Link as NavLink } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import '../styles/ContactSection.scss';
import { yupResolver } from '@hookform/resolvers/yup';
import { Icon } from '@iconify/react';
import { Zoom, Bounce } from 'react-awesome-reveal';
import { Controller, useForm } from 'react-hook-form';
import CustomButton from '../../../../../components/buttons/CustomButton';
import { postContactUsAction } from '../../../../../redux/reducer/commonSlices/contactUs';
import { useAppSelector } from '../../../../../../app/redux/hooks';
import sectionConstants from '../../constants/SectionConstants';
import { useRef } from 'react';
import PhoneNoTextField from '../../../../../components/customized/customtextfield/PhoneNoTextField';
import { contactSectionFields } from './componentDatas/ContactSectionData';
import { useContactFormSubmission } from './componentDatas/FieldControl';
import { useDynamicYupSchema } from '../../../../../hooks/useDynamicSchema';

const sitekey = String(process.env.REACT_APP_RECAPTCHA_KEY);

const ContactSection1 = () => {
  const captchaRef = useRef(null);
  const themes = useAppSelector(state => state.theme.theme);
  const { isLoading } = useAppSelector(state => state.contactUs);

  const urls = [{ url: postContactUsAction, payload: null }];

  const { createFormFields }: any = useDynamicYupSchema(null);

  const { schema } = createFormFields(contactSectionFields());

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  } as any);

  const { onSubmit } = useContactFormSubmission(urls, captchaRef, reset);

  return (
    <Box>
      <Box className='contact-section-image'>
        <Stack
          className='contact-heading'
          alignItems='center'
          direction='row'
          justifyContent='center'
        >
          <Box className='box-container'>
            <Bounce>
              <Grid container spacing={3} justifyContent='space-around'>
                <Grid item xs={12} sm={4}>
                  <Box className='border-line'>
                    <Icon className='icon-style' icon='ion:map-outline' />
                    <Typography className='contact-address-heading'>
                      {sectionConstants.AddressVar}
                    </Typography>
                    <Typography className='contact-address-data'>
                      <NavLink
                        href={
                          themes == 'ayka'
                            ? 'https://maps.app.goo.gl/YPVTHSVr78cgp38aA'
                            : 'https://goo.gl/maps/smWnpVCztncGGFWX9'
                        }
                        target='_blank'
                      >
                        {sectionConstants.Address}
                      </NavLink>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box className='border-line'>
                    <Icon className='icon-style' icon='basil:phone-outline' />
                    <Typography className='contact-address-heading'>
                      {sectionConstants.Phone}
                    </Typography>
                    <Typography className='contact-address-data'>
                      <NavLink href={`tel:${sectionConstants.mobilenumber}`}>
                        {sectionConstants.mobilenumber}
                      </NavLink>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box>
                    <Icon className='icon-style' icon='majesticons:mail-line' />
                    <Typography className='contact-address-heading'>
                      {sectionConstants.Email}
                    </Typography>
                    <NavLink href={`mailto:${sectionConstants.email}`}>
                      <Typography className='contact-address-data'>
                        {sectionConstants.email}
                      </Typography>
                    </NavLink>
                  </Box>
                </Grid>
              </Grid>
            </Bounce>
          </Box>
        </Stack>
      </Box>
      <Box className='new-section'>
        <Zoom>
          <Box className='new-container'>
            <Typography
              className='new-container-heading'
              variant='h5'
              style={{ color: 'black', marginBottom: '2px' }}
            >
              {sectionConstants.HaveQuestions}
            </Typography>
            <Typography
              className='new-container-heading primary-color'
              variant='h5'
              mb='25px'
            >
              {sectionConstants.ConnectWithUs}
            </Typography>
          </Box>
        </Zoom>
      </Box>
      <Zoom>
        <Box className='form-box-contact-section'>
          <Box className='form-container' sx={{ padding: '20px', borderRadius: '7px' }}>
            <Stack
              component='form'
              direction='column'
              spacing={2}
              onSubmit={handleSubmit(onSubmit)}
            >
              <Controller
                name='name'
                control={control}
                defaultValue=''
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type='text'
                    label={
                      <span>
                        Name<span style={{ color: 'red' }}> *</span>
                      </span>
                    }
                    className='new-form'
                    inputProps={{
                      maxLength: 30
                    }}
                    InputLabelProps={{ style: { color: 'black' } }}
                  />
                )}
              />
              {errors?.name && (
                <Typography className='error-msg'>
                  {errors.name?.message?.toString() ?? ''}
                </Typography>
              )}
              <Controller
                name='email'
                control={control}
                defaultValue=''
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type='text'
                    label={
                      <span>
                        Email ID<span style={{ color: 'red' }}> *</span>
                      </span>
                    }
                    className='new-form'
                    InputLabelProps={{ style: { color: 'black' } }}
                  />
                )}
              />
              {errors.email && (
                <Typography className='error-msg'>
                  {errors?.email?.message?.toString()}
                </Typography>
              )}

              <Controller
                name='phone'
                control={control}
                defaultValue=''
                rules={{ required: true }}
                render={({ field }) => (
                  <PhoneNoTextField
                    {...field}
                    setValue={setValue}
                    getValues={getValues}
                    name={'phone'}
                  />
                )}
              />
              {errors.phone && (
                <Typography className='error-msg'>
                  {errors?.phone?.message?.toString()}
                </Typography>
              )}
              <Controller
                name='message'
                control={control}
                defaultValue=''
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type='text'
                    label={
                      <span>
                        Message <span style={{ color: 'red' }}> *</span>
                      </span>
                    }
                    className='new-form'
                    inputProps={{
                      maxLength: 50
                    }}
                    InputLabelProps={{ style: { color: 'black' } }}
                  />
                )}
              />
              {errors.message && (
                <Typography className='error-msg'>
                  {errors?.message?.message?.toString()}
                </Typography>
              )}
              <ReCAPTCHA sitekey={sitekey} ref={captchaRef} onChange={() => {}} />
              <CustomButton
                type='submit'
                className='saveChanges'
                category='Submit'
                sx={{ color: 'white', alignSelf: 'flex-end' }}
                loading={isLoading}
              />
            </Stack>
          </Box>
        </Box>
      </Zoom>
    </Box>
  );
};

export default ContactSection1;
